import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { useEffect, useRef } from 'react';
import { loginState, configState } from "../lib/State";
import get_cid from "../lib/get_cid";

function Test5() {

  const cid = get_cid();

  const data = {
    onfftid: 'OFPT000000000071',
    merchant_uid: `mid_${new Date().getTime()}`,
    memid: 'ngylove',
    amt: '1004',
    buyer_nm: '노곰돌',
    user_phone: '01071513274',
    product_nm: '충전기',
    cnclUrl: configState.api+'/gympass/order_cancel',
    rtnUrl: configState.api+'/gympass/order_return',
    callUrl : configState.api+'/gympass/order_call',
    app_scheme : 'myawesomeapp', // iphone app_scheme
  }

  console.log(data);

  const formRef = useRef(null);

  const onButtonClick = () => {
    // formRef.current.target = 'onoff';
    formRef.current.submit();
  }

  const closeWindow = () => {
    window.close();
  }

  // cardpay_window_open   

  // // add event
  // useEffect(() => {
  //   const div = innerRef.current;
  //   // subscribe event
  //   div.addEventListener("scroll", handleOnScroll);
  //   return () => {
  //     // unsubscribe event
  //     div.removeEventListener("scroll", handleOnScroll);
  //   };
  // }, []);

  // 이벤트등록#1
  // function logic() {
  //   console.log( window.pageYOffset );
  // }
  // useEffect(() => {
  //   function watchScroll() {
  //     window.addEventListener("scroll", logic);
  //   }
  //   watchScroll();
  //   return () => {
  //     window.removeEventListener("scroll", logic);
  //   };
  // },[]);

  // 이밴트등록 #2
  // const innerRef = useRef(null);
  // function logic() {
  //   console.log( window.pageYOffset );
  // }
  // useEffect(() => {
  //   const div = innerRef.current;
  //   function watchScroll() {
  //     div.addEventListener("scroll", logic);
  //   }
  //   watchScroll();
  //   return () => {
  //     div.removeEventListener("scroll", logic);
  //   };
  // },[]);  


  return <div>

    {/* <form ref={formRef} name="frm" method="POST" action="https://store.onoffkorea.co.kr/isp/card_approval.php"> */}   
    <form ref={formRef} name="frm" method="POST" action="https://store.onoffkorea.co.kr/isp_m/approval_newplus.php">
      <input type="hidden" name="onfftid" value={data.onfftid} />
      <input type="hidden" name="ssid" value={data.merchant_uid} />
      <input type="hidden" name="memid" value={data.memid} />
      <input type="hidden" name="amt" value={data.amt} />
      <input type="hidden" name="com_tax_amt" value="0" />
      <input type="hidden" name="com_vat_amt" value="0" />
      <input type="hidden" name="com_free_amt" value="0" />
      <input type="hidden" name="buyer_nm" value={data.buyer_nm} />
      <input type="hidden" name="user_phone" value={data.user_phone} />
      <input type="hidden" name="user_email" value="" />
      <input type="hidden" name="product_nm" value={data.product_nm} />
      <input type="hidden" name="cnclUrl" value={data.cnclUrl} />
      <input type="hidden" name="rtnUrl" value={data.trnUrl} />
      <input type="hidden" name="callUrl" value={data.callUrl} />
      <input type="hidden" name="app_scheme" value={data.app_scheme} />
    </form>

    <Box>
      <Button variant="contained" onClick={onButtonClick}>결제시작</Button>
      {/* <Button variant="contained" onClick={closeWindow}>창닫기</Button> */}
    </Box>
    <Box display="flex" justifyContent="center">
    <iframe
      width="900" height="900" name="onoff" scrolling="no" style={{
        border: 0,
        margin: 0,
        padding: 0,
        overflow: "hidden"
      }}></iframe>
      </Box>

  </div>
}

export default Test5;